module.exports = __webpack_public_path__ + "static/img/017.d50284b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-head/017.png
// module id = mCX6
// module chunks = 1